import { Column, RawColumn } from '../models';

/**
 * Since don't have a standardized LOV system, for some fields we need to look into
 * different places between field to field, therefore additional `dataKey` to Column.
 * the precedence order to find the dataKey to use will be
 *  1. Column
 *  2. 'value' as default
 *
 * @example
 * // given
 * const column1 = { field: 'foo' }
 * const column2 = { field: 'bar', lookupValueKey: 'value' }
 * const column3 = { field: 'baz', lookupValueKey: 'name' }

 * // when
 * getLovDataKey(column1); //> 'key'
 * getLovDataKey(column2); //> 'value'
 * getLovDataKey(column3); //> 'name'
 *
 * // If LOVs are given like
 * [
 *  { key: 1, value: 'x', name: 'XX'},
 * ]
 *
 * // then
 * // column1 will read 1
 * // column2 will read 'x'
 * // column3 will read 'XX'
 *
 * @param column
 * @returns string
 */
export function getLovValueKey<T extends RawColumn = Column>(column: Pick<T, 'lookupValueKey'>) {
  let key = 'key';
  if (column && column.lookupValueKey) {
    key = column.lookupValueKey;
  }
  return key;
}
